import { UserAccountMenu } from './UserAccountMenu';

export { UserAccountMenu };
export default UserAccountMenu;
